
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias/ultimas-noticias",
      function () {
        return require("private-next-pages/noticias/ultimas-noticias/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias/ultimas-noticias"])
      });
    }
  